<template>
    <div class="truncate" :title="props.displayName ?? undefined">
        <vx-badge color="slate" size="xs" class="font-mono" data-test="brand-id">
            {{ props.brandId }}
        </vx-badge>
        <span class="ml-2 text-xs font-bold" data-test="brand-name">{{ props.displayName || '—' }}</span>
    </div>
</template>

<script lang="ts" setup>
import { VxBadge } from '@voxie/frontend-components';

const props = defineProps<{
    brandId: string;
    displayName: string | null;
}>();
</script>
